<template>
  <div>
    <header-bar>YouTube連絡票</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">YouTube情報登録</h3>
      </div>
      <div class="page-block__inner">
        <p class="date-text">{{ text }}</p>
        <form
          :class="{ 'form--error': false }">
          <div class="profile-info">
            <div class="form-wrap form-wrap--profile u-no-margin-top">
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="artist_name_domestic">URL
                    <span class="req">＊</span>
                  </label>
                </div>
                <div
                  class="form-item">
                  <input
                    id="youtube_url"
                    v-model="url"
                    class="form-control"
                    :placeholder="placeholder.url"
                    type="text"
                    :disabled="disableForm"
                    @focus="urlError = ''">
                  <button
                    v-if="!disableForm"
                    class="c-btn c-btn--preview"
                    :disabled="!url"
                    @click.prevent="preview">
                    プレビュー
                  </button>
                  <p
                    class="error-text">
                    {{ urlError }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="artist_name_domestic">楽曲名
                    <span class="req">＊</span>
                  </label>
                </div>
                <div
                  class="form-item">
                  <div v-show="!manualAdd">
                    <v-select
                      ref="songSelect"
                      v-model="songTitle"
                      :options="filteredOptions"
                      :filterable="false"
                      :disabled="disableForm"
                      placeholder="手入力または検索で選択してください"
                      @search="onSearch">
                      <template slot="no-options">
                        該当する楽曲が見つかりません。
                        手動で登録する場合は、追加ボタンを押してください。
                        <button
                          class="c-btn"
                          @click.prevent="onManualAdd">
                          追加
                        </button>
                      </template>
                    </v-select>
                  </div>
                  <div v-show="manualAdd">
                    <div
                      class="form-item">
                      <input
                        v-model="songTitle"
                        class="form-control"
                        type="text">
                    </div>
                  </div>
                  <p
                    class="error-text">
                    {{ songTitleError }}
                  </p>
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <button
                class="c-btn"
                :disabled="disableForm"
                @click.prevent="save">
                登録
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="page-block">
        <div class="page-block__inner">
          <div class="my-release-search-wrap">
            <div class="my-release-search-text">検索</div>
            <form>
              <input
                v-model="keyword"
                class="my-release-search"
                type="search">
            </form>
            <a
              class="c-btn c-btn--search"
              @click.prevent="fetchItems">
              <img
                src="/img/common/icon-search.png"
                alt="">検索
            </a>
          </div>
          <div class="report-block profit">
            <div
              class="report-profit-area">
              <div class="report-profit-area__column">
                <div class="report-profit-area__wrap">
                  <table class="report-profit-area__table">
                    <thead class="report-profit-area__thead">
                      <tr>
                        <th>YouTube URL</th>
                        <th>
                          楽曲名
                        </th>
                        <th>作品コード</th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="items.length > 0"
                      class="report-profit-area__tbody">
                      <tr
                        v-for="item in items"
                        :key="item.id" >
                        <td>
                          <a
                            :href="item.url"
                            target="_blank">{{ item.url }}
                          </a>
                        </td>
                        <td>{{ item.song_title }}</td>
                        <td>{{ item.work_code }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else >
                      <tr>
                        <td
                          class="empty-cell"
                          colspan="3">
                          YouTube情報はありません
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-dialog
        name="youtube-preview"
        :is-shown="isShown"
        :is-footer="false"
        @closed="isShown=false; isPlaying = false">
        <template #body>
          <div class="youtube-wrapper">
            <div
              v-if="!isPlaying"
              class="thumbnail"
              @click="playVideo">
              <img
                :src="thumbnailUrl"
                :alt="videoId" />
              <button class="play-button">▶</button>
            </div>
            <template v-else>
              <iframe
                v-if="canEmbed"
                width="560"
                height="315"
                :src="embedUrl"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write;
                 encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
              <a
                v-else
                :href="watchUrl"
                target="_blank"
                rel="noopener noreferrer">
                Watch on YouTube
              </a>
            </template>
          </div>
        </template>
      </confirm-dialog>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import HeaderBar from '../../HeaderBar'
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'YouTubeContactIndex',
  components: {
    ConfirmDialog,
    HeaderBar,
  },
  data() {
    return {
      disableForm: false,
      songTitleSearch: '',
      urlError: '',
      songTitleError: '',
      url: '',
      songTitle: '',
      isValidUrl: true,
      isShown: false,
      keyword: null,
      offset: 0,
      items: [
        {
          id: '',
          url: '',
          song_title: '',
          work_code: '',
        },
      ],
      text: '入力期限外のため入力できません。',
      isPlaying: false,
      placeholder: {
        url: 'https://www.youtube.com/xxxxxxxxx',
        song_title: '楽曲名',
      },
      copyrightTrackTitles: [],
      searchText: '',
      manualAdd: false,
    }
  },
  mounted() {
    if (!this.$store.state.auth.company.enable_youtube_monetize_menu) {
      this.$router.push({ name: 'index' })
      return
    }
    this.fetchItems()
    this.getQuarterInfo()
    this.fetchCopyrightTrackTitles()
  },
  computed: {
    videoId() {
      try {
        const u = new URL(this.url)
        if (u.hostname.includes('youtu.be')) {
          return u.pathname.split('/')[1]
        }
        if (u.hostname.includes('youtube.com')) {
          if (u.searchParams.get('v')) return u.searchParams.get('v')
          const paths = u.pathname.split('/')
          if (['shorts', 'embed', 'live'].includes(paths[1])) return paths[2]
        }
      } catch (e) {
        return ''
      }
      return ''
    },
    thumbnailUrl() {
      return this.videoId ? `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg` : ''
    },
    embedUrl() {
      return this.videoId ? `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0` : ''
    },
    watchUrl() {
      return this.videoId ? `https://www.youtube.com/watch?v=${this.videoId}` : ''
    },
    canEmbed() {
      return !this.url.includes('shorts')
    },
    filteredOptions() {
      const s = this.normalize(this.searchText)
      return this.copyrightTrackTitles.filter(title => this.normalize(title).includes(s))
    },
  },
  methods: {
    getQuarterInfo() {
      const now = moment()

      const releaseDate = '2025-12-11' // release date

      if (!releaseDate) {
        return []
      }

      const firstStart = moment(releaseDate).startOf('day')
      const firstEnd = firstStart.clone()
        .add(3, 'months')
        .startOf('month')
        .add(4, 'days')
        .endOf('day')

      if (now.isBefore(firstStart)) {
        this.disableForm = true
        return []
      }

      if (now.isBefore(firstEnd)) {
        this.text = `${firstStart.format('M月D日')}〜${firstEnd.format('M月D日')}に再生されたYouTubeの情報を入力してください。`
        return this.text
      }

      const adjustedBase = firstStart.clone().subtract(5, 'days')
      const monthsFloat = now.diff(adjustedBase, 'months', true)

      const periodIndex = Math.floor(monthsFloat / 3)
      const periodStart = adjustedBase.clone()
        .add(periodIndex * 3, 'months')
        .startOf('day')
      const periodEnd = periodStart.clone()
        .add(3, 'months')
        .subtract(1, 'day')
        .endOf('day')

      this.text = `${periodStart.format('M月D日')}〜${periodEnd.format('M月D日')}に再生されたYouTubeの情報を入力してください。`

      return this.text
    },
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/youtube-contacts', {
        params: {
          keyword: this.keyword,
        },
      })
      this.items = data.data
    },
    async fetchCopyrightTrackTitles() {
      const { data } = await window.axios.get('/api/client/copyright-titles')
      this.copyrightTrackTitles = data
    },
    validateInput(onlyUrl = false) {
      let valid = true
      this.urlError = ''
      this.songTitleError = ''
      if (!this.url || this.url.trim().length === 0) {
        valid = false
        this.isValidUrl = false
        this.urlError = 'URLは必須項目です。'
        if (!this.songTitle || this.songTitle.trim().length === 0) {
          this.isValidUrl = false
          valid = false
          this.songTitleError = '楽曲名は必須項目です。'
        }
        return valid
      }
      const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})([&?]\S*)?$/
      if (!pattern.test(this.url)) {
        this.urlError = '正しいURLの形式で入力してください'
        this.isValidUrl = false
        valid = false
      }
      if (onlyUrl) {
        return valid
      }
      if (!this.songTitle || this.songTitle.trim().length === 0) {
        this.isValidUrl = false
        valid = false
        this.songTitleError = '楽曲名は必須項目です。'
      }
      return valid
    },
    async save() {
      if (this.validateInput()) {
        try {
          await window.axios.post('/api/client/youtube/contacts', {
            url: this.url,
            song_title: this.songTitle,
          })
          this.url = ''
          this.songTitle = ''

          if (this.manualAdd) {
            this.manualAdd = false
          }

          await this.fetchItems()
        } catch (err) {
          if (err.response.status === 422) {
            const { errors } = err.response.data
            this.urlError = (errors.url && errors.url[0]) || ''
            this.songTitleError = (errors.song_title && errors.song_title[0]) || ''
          }
        }
      }
    },
    preview() {
      if (this.validateInput(true)) {
        this.isShown = true
      }
    },
    playVideo() {
      this.isPlaying = true
    },
    onSearch(keyword) {
      this.searchText = keyword
    },
    normalize(str) {
      if (!str) return ''
      // eslint-disable-next-line no-param-reassign
      if (typeof str !== 'string') str = String(str)

      try {
        return str.normalize('NFKC').toLowerCase().trim()
      } catch {
        return String(str).toLowerCase().trim()
      }
    },
    onManualAdd() {
      this.manualAdd = true
      this.songTitle = this.searchText
    },
  },
}
</script>
<style scoped>
  >>> .vs__search::placeholder {
    color: #d4cdc8;
  }
  >>> .vs__open-indicator {
    fill: #ff6c00 !important;
  }
  >>> .vs__actions button {
    padding-top: 5px !important;
  }
  @media screen and (min-width: 896px) {
    .form-control {
      width: 79%;
    }
    .c-btn--preview {
      min-width: inherit;
      padding: 7px 22px 7px 22px;
      text-align: center;
      margin-left: 20px;
    }
    >>> .vs__dropdown-toggle {
      padding: 8px 2px !important;
      border-radius: 0 !important;
    }
  }
  @media screen and (max-width: 895px) {
    .c-btn--preview {
      margin-top:1vw;
    }
    >>> .vs__dropdown-toggle {
      padding: 12px 2px !important;
      border-radius: 0 !important;
    }
  }
  .date-text {
    padding-bottom: 2rem;
  }
  .error-text{
    display: block;
  }
  .my-artist-search:disabled {
    background-color: #f0f0f0;
    cursor: not-allowed;
  }
  .btn--disabled:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .youtube-wrapper {
    position: relative;
    width: 560px;
    height: 315px;
    margin-left: 15px;
  }
  .thumbnail {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,0.6);
    color: white;
    border: none;
    border-radius: 50%;
    font-size: 2rem;
    padding: 10px 20px;
    cursor: pointer;
  }
  .form-control:disabled {
    background: #f8f8f8 !important;
    cursor: not-allowed;
  }
</style>
